"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOCK_TESTS = exports.MOCK_TEST = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../../fragments");
exports.MOCK_TEST = (0, client_1.gql) `
  ${fragments_1.MOCK_TEST_FIELDS}
  query MockTest($id: Int!) {
    restricted {
      mockTest(id: $id) {
        ...MockTestFields
      }
    }
  }
`;
exports.MOCK_TESTS = (0, client_1.gql) `
  ${fragments_1.MOCK_TEST_FIELDS}
  query MockTests($typeIds: [Int!]) {
    restricted {
      mockTests(typeIds: $typeIds) {
        ...MockTestFields
      }
    }
  }
`;
